import { Collapse, Table } from "antd";
import { FC } from "react";
import { BiPlus } from "react-icons/bi";
import { IoReload } from "react-icons/io5";
import useCategoryStatusTable, {
  Props,
  ReceivedProps,
  isOptionNull,
} from "./hook";

import { Styles } from "./styled";
import ModalConfirm from "@lhd/components/Modal/ModalConfirm";
import ModalEditConfirm from "@lhd/components/Modal/ModalEditConfirm";
import ButtonCommon from "@lhd/components/ButtonCommon";

const CONSTANT_TEXT_CATEGORY_STATUS: any = {
  workers: {
    status: "現職/退職",
    category: "契約種別",
  },
  taxsheet: {
    status: "現職/退職",
    category: "契約種別",
  },
  app: {
    status: "ステータス",
    category: "カテゴリー",
  },
  client: {
    status: "取引ステータス",
    category: "契約種別",
  },
  project_manage: {
    status: "ステータス",
    category: "カテゴリー",
  },
  performance_appraisal: {
    status: "発行状態",
    category: "",
  },
  appraisal_sheets: {
    status: "ステータス",
    category: "",
  },
  company_policies: {
    status: "ステータス",
    category: "カテゴリー",
  },
  business_manuals: {
    status: "ステータス",
    category: "カテゴリー",
  },
};

const CategoryStatusTableLayout: FC<Props> = ({
  columns,
  dataSource,
  handleAddNewRow,
  recordType,
  screen,
  isSubmitting,
  isFetching,
  isLoading,
  nonEditable,
  refetch,
  modalConfirm,
  onCloseModalConfirm,
  modalEditConfirm,
  handleConfirmEdit,
  handleCancelEdit,
  displaySize,
  height,
  size,
}) => {
  return (
    <Styles text_scale={displaySize}>
      <div className="container">
        <Collapse
          defaultActiveKey={[`${screen}_${recordType}`]}
          expandIconPosition={"right"}
          expandIcon={({ isActive }: any) =>
            isActive ? (
              <ButtonCommon
                name="非表示"
                onClick={() => null}
                className="btn-collapse"
              />
            ) : (
              <ButtonCommon
                name="表示"
                onClick={() => null}
                className="btn-collapse"
              />
            )
          }
        >
          <Collapse.Panel
            header={
              <div>
                <p className="status">
                  {recordType === "status" ? "ステータス" : "カテゴリー"}
                </p>
                <p className="extract-column">
                  抽出列【
                  {CONSTANT_TEXT_CATEGORY_STATUS?.[screen]?.[recordType] || ""}
                  】
                </p>
              </div>
            }
            key={`${screen}_${recordType}`}
          >
            <div className="tableWrapper">
              <ButtonCommon
                name="リロード"
                icon={
                  <div className="flex-center">
                    <IoReload size={18} />{" "}
                  </div>
                }
                onClick={() => {
                  refetch();
                }}
                className="btn-create mb-2"
                style={{
                  fontSize: size,
                  height: `${height}px`,
                  width: "fit-content",
                  gap: 5,
                }}
              />
              <Table
                key={`${screen}_${recordType}`}
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                loading={isSubmitting || isFetching || isLoading}
              />

              {!nonEditable && (
                <div className="full-w d-flex justify-center mt-2">
                  <ButtonCommon
                    name="行追加"
                    icon={
                      <div className="flex-center">
                        <BiPlus size={18} />{" "}
                      </div>
                    }
                    style={{
                      fontSize: size,
                      height: `${height}px`,
                      width: "fit-content",
                      gap: 5,
                    }}
                    onClick={handleAddNewRow}
                    className="btn-create"
                  />
                </div>
              )}
            </div>
          </Collapse.Panel>
        </Collapse>
      </div>

      <ModalConfirm
        isSubmitting={isLoading}
        isOpen={modalConfirm?.isOpen}
        onCancel={onCloseModalConfirm}
        onOk={modalConfirm?.callback}
        content={modalConfirm?.content}
      />

      <ModalEditConfirm
        isOpen={modalEditConfirm?.isOpen}
        content="現在使用中の値です。変更すると関連データにも更新が反映されます。 更新してよろしいですか？"
        onConfirm={() =>
          handleConfirmEdit(modalEditConfirm?.saveType ?? "current_company")
        }
        onCancel={handleCancelEdit}
        isSubmitting={isSubmitting}
      />
    </Styles>
  );
};

const CategoryStatusTable: FC<ReceivedProps> = (props) => (
  <CategoryStatusTableLayout {...useCategoryStatusTable(props)} />
);

export { isOptionNull };
export default CategoryStatusTable;
